module.exports = __webpack_public_path__ + "static/media/19-15.665a8d87.mp3";